import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import parse from "html-react-parser"
import NewsLetter from "components/_newsletter/NewsLetter"

const HomeNews = () => {
  const data = useStaticQuery(graphql`
    query {
      wpContentSettings(id: { eq: "cG9zdDoyMQ==" }) {
        home {
          newsTopTitle
          newsTitle
        }
      }
      allWpPost(limit: 2, sort: { date: DESC }) {
        nodes {
          title
          excerpt
          uri
          featuredImage {
            node {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: DOMINANT_COLOR
                    quality: 80
                  )
                }
              }
            }
          }
        }
      }
    }
  `)

  const homeNews = data.allWpPost.nodes
  const { newsTopTitle, newsTitle } = data.wpContentSettings.home

  return (
    <>
      <div className="row text-center">
        <div className="col-lg-10 col-xl-10 col-xxl-8 mx-auto">
          <h2 className="fs-17 text-uppercase text-muted mb-3">
            {newsTopTitle}
          </h2>
          <h3 className="display-4 mb-9">{newsTitle}</h3>
        </div>
      </div>

      <div className="row">
        {homeNews.map(proj => (
          <div className="col-lg-6">
            <figure>
              <div className="overlay overlay-1 hover-scale ">
                <Link to={`/news${proj.uri}`}>
                  <GatsbyImage
                    image={
                      proj.featuredImage?.node?.localFile?.childImageSharp
                        ?.gatsbyImageData
                    }
                    alt={proj.featuredImage?.node?.altText}
                    className="img-fluid rounded mb-6"
                  />
                  <span className="bg rounded" />
                </Link>
                <figcaption>
                  <h3 className="from-top mb-0">Read this article</h3>
                </figcaption>
              </div>
            </figure>
            <Link to={`/news${proj.uri}`} className="post-header">
              <h3>{proj.title}</h3>
            </Link>
            <p className="mt-3">{parse(proj.excerpt)}</p>
          </div>
        ))}
      </div>
      <div className="row">
        <NewsLetter />
      </div>
    </>
  )
}

export default HomeNews
